const defaultState = {
  block: {
    id: 0,
    name: '',
    block_type: '',
    detail_style: '',
    meta: {
      autofill: 'none',
      hide_name: false,
      pill_text: null,
      android_auto_icon: null,
    },
    items: [],
    totalItems: 0,
    limit: 4,
    image_url: '',
    background_image_url: null,
    text_color: null,
    condition_name: null
  },
}

export default {
  state: {
    ...defaultState,
    allItems: [],
    totalItems: 0,
  },

  getters: {
    bblockById: (state) => (id) => {
      if (String(state.block.id) === String(id)) {
        return state.block
      }
      return null
    },

    allItems: (state) => {
      return state.allItems
    },

    totalItems: (state) => {
      return state.totalItems
    },

    filteredAllItems: (state) => {
      // filter items already moved to list by id and content_type
      const itemIds = state.block.items.map(it => it.item_id)
      return state.allItems.filter((it) => {
        if (!itemIds.includes(it.item_id)) {
          return it
        }
      })
    },

  },

  actions: {
    getBlock({ commit, dispatch }, { $api, id }) {
      $api.get(`block/${id}`)
        .then((response) => {
          commit('setBlock', response.data)
        })
        .catch(error => dispatch('throwError', error))
    },

    getAllItems({ commit, dispatch }, {
      $api,
      search = '',
      type = 'episode',
      limit = 10,
      page = 1
    }) {
      dispatch('loading', true)
      if (type === 'episode') {
        $api.get(`episodes/?q=${search}&limit=${limit}&page=${page}`)
          .then((response) => {
            commit('setAllItems', {
              items: response.data.episodes,
              type: 'episode',
              total: response.data.total
            })
            dispatch('loading', false)
          })
          .catch(error => dispatch('throwError', error))
      } else if (type === 'podcast') {
        $api.get(`podcasts/?q=${search}&limit=${limit}&page=${page}`)
          .then((response) => {
            commit('setAllItems', {
              items: response.data.podcasts,
              type: 'podcast',
              total: response.data.total
            })
            dispatch('loading', false)
          })
          .catch(error => dispatch('throwError', error))
      } else if (type === 'link') {
        $api.get(`links/?q=${search}&limit=${limit}&page=${page}`)
          .then((response) => {
            commit('setAllItems', {
              items: response.data.links,
              type: 'link',
              total: response.data.total
            })
            dispatch('loading', false)
          })
          .catch(error => dispatch('throwError', error))
      }
    },

    newBlock({ commit, dispatch, state }, { $api, $router }) {
      commit('deleteBlockZero')
      $api.post('block/', (({ name, block_type, detail_style, limit, meta, system_name, condition_name, condition_value, title, description, onboarding, image_url, background_image_url, text_color }) =>
                                ({ name, block_type, detail_style, limit, meta, system_name, condition_name, condition_value, title, description, onboarding, image_url, background_image_url, text_color }))(state.block))
        .then((response) => {
          commit('setNewBlock', response.data.id)
          $router.push({ path: `${response.data.id}` })
        })
        .catch(error => dispatch('throwError', error))
    },

    saveBlock({ dispatch, getters, state }, { $api }) {
      dispatch('loading', true)
      $api.put('block/', (({ id, name, block_type, detail_style, limit, meta, system_name, condition_name, condition_value, title, description, onboarding, image_url, background_image_url, text_color  }) =>
                               ({ id, name, block_type, detail_style, limit, meta, system_name, condition_name, condition_value, title, description, onboarding, image_url, background_image_url, text_color }))(state.block))
        .then(() => {
          if (getters.blockUsesAutofill) {
            console.log('autofill block')
          } else {
            dispatch('saveItemsToBlock', { $api })
          }
        })
        .catch((error) => {
          if (error.response.data.message || error.response.data.detail.message || error.response.data.detail) {
            dispatch('throwError',  {
                hasError: error.response.data.message || error.response.data.detail.message || error.response.data.detail,
            })
          } else {
            dispatch('throwError', error)
          }
        })
    },

    saveItemsToBlock({ state, dispatch }, { $api }) {
      const id = state.block.id
      // get rid of the old items first
      $api.delete(`remove_items_from_block/?block_id=${id}`)
        .then(() => {
          const ids = state.block.items.map((b, i) => [b.id, b.content_type, i])
          $api.post('save_items_to_block/', {
            items: ids,
            block_id: id
          })
            .then(() => dispatch('loading', false))
        })
    },

    deleteBlock({ dispatch, state }, { $api, $router }) {
      $api.delete(`block/${state.block.id}`)
        .then(() => {
          $router.push({ path: '/blocks' })
        })
        .catch((error) => {
          if (error.response.status === 405) {
            dispatch('throwError', {
              hasError: error.response.data.message || error.response.data.detail.message,
              errorAction: error.response.data.action || error.response.data.detail.action
            })
          } else {
            dispatch('throwError', error)
          }
        })
    },

  },

  mutations: {
    setBlock(state, data) {
      data.items.forEach((it) => {
        it.item_id = `${it.id}-${it.content_type}`
      })
      data.condition_value = true;
      state.block = data
    },

    setNewBlock(state, id) {
      state.block = {
        ...state.block, id, items: []
      }
    },

    clearBlock(state) {
      state.block = { ...defaultState.block }
    },

    deleteBlockZero(state) {
      if (state.block.id === 0) {
        delete state.block.id
      }
    },

    setHidenameBlock(state) {
      state.block.meta.hide_name = !state.block.meta.hide_name
    },

    setPilltextBlock(state, { pill_text }) {
      state.block.meta.pill_text = pill_text
    },

    setAndroidAutoIconBlock(state, { android_auto_icon }) {
      state.block.meta.android_auto_icon = android_auto_icon
    },

    setLimitBlock(state, { limit }) {
      state.block.limit = limit
    },

    setAutofillBlock(state, { autofill }) {
      state.block.meta.autofill = autofill
    },

    setAllItems(state, { items, type, total }) {
      items.forEach((it) => it.content_type = type)
      items.forEach((it) => it.item_id = `${it.id}-${type}`)
      state.allItems = items
      state.totalItems = total
    },

    resetItems(state) {
      state.block.items = []
    },

    addItem(state, { item_id }) {
      const item = state.allItems.find(it => it.item_id === item_id)
      state.block.items.unshift(item)
    },

    moveItem(state, { oldIndex, newIndex }) {
      const items = state.block.items
      items.splice(newIndex, 0, items.splice(oldIndex, 1)[0])
      state.block.items = items
    },

    removeItem(state, { item_id }) {
      state.block.items = state.block.items.filter(it => it.item_id !== item_id)
    },

  }
}
